<template>
  <transition-group
    name="asc-fleet-tail-cardset"
    tag="div"
    class="columns is-multiline"
  >
    <asc-fleet-tail-card
      v-for="item in managedItems"
      :key="item.text"
      class="column is-4 asc-fleet-tail-cardset--item"
      :item="item"
      :is-issue-investigator="isIssueInvestigator"
      :is-issue-reader="isIssueReader"
      :is-issue-updater="isIssueUpdater"
      :on-open-maintenance="onOpenMaintenance"
      :on-open-fde="onOpenFde"
      :on-open-connectivity="onOpenConnectivity"
    ></asc-fleet-tail-card>
  </transition-group>
</template>

<script>
import AscFleetTailCard from '../molecules/AscFleetTailCard.vue'

export default {
  name: 'AscFleetTailCardset',

  components: {
    AscFleetTailCard,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isIssueInvestigator: {
      type: Boolean,
      default: false,
    },
    isIssueReader: {
      type: Boolean,
      default: false,
    },
    isIssueUpdater: {
      type: Boolean,
      default: false,
    },
    onOpenMaintenance: {
      type: Function,
      default: () => {},
    },
    onOpenFde: {
      type: Function,
      default: () => {},
    },
    onOpenConnectivity: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      managedItems: this.items,
    }
  },

  watch: {
    items(newVal) {
      this.managedItems = newVal
    },
  },
}
</script>

<style lang="scss">
.asc-fleet-tail-cardset--item {
  transition: all 0.5s;
  display: inline-block;
}
</style>
